import { render, staticRenderFns } from "./IconProgress.vue?vue&type=template&id=6879b563&scoped=true"
import script from "./IconProgress.vue?vue&type=script&lang=js"
export * from "./IconProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6879b563",
  null
  
)

export default component.exports